import { FavouritesStorage } from "widgets-module/components/favourites/favourites-storage.service";

export class FavouritesControl {

    private _storage: FavouritesStorage = null;
    private _currentContext: JQuery = null;
    private _pageKey: string = null;
    private _addButton: JQuery = null;
    private _removeButton: JQuery = null;

    private _classMap = {
        addButton: ".js-add-to-favourites",
        removeButton: ".js-remove-from-favourites"
    };

    private toggleButtons(isAddToFavourite: boolean): void {
        this._addButton.toggle(isAddToFavourite);
        this._removeButton.toggle(!isAddToFavourite);
    }

    private bindEvents(): void {
        this._addButton.on("click", (e) => {
            e.preventDefault();
            this._storage.add(this._pageKey);
            this.toggleButtons(false);
        });

        this._removeButton.on("click", (e) => {
            e.preventDefault();
            this._storage.remove(this._pageKey);
            this.toggleButtons(true);
        });
    }

    private setState(): void {
        const currentPageIsVafourite = this._storage.has(this._pageKey);
        this.toggleButtons(!currentPageIsVafourite);
    }

    private parseContext(): void {
        this._addButton = $(this._classMap.addButton, this._currentContext);
        this._removeButton = $(this._classMap.removeButton, this._currentContext);
    }

    public init(context: JQuery, pageKey: string, cookieName: string, cookieSplitter: string): void {
        this._currentContext = context || this._currentContext;
        this._pageKey = pageKey || this._pageKey;
        this._storage = new FavouritesStorage(cookieName, cookieSplitter);

        this.parseContext();
        this.setState();
        this.bindEvents();
    }

}
